import { Injectable } from '@angular/core';

@Injectable()
export class UtilsServiceProvider {
	constructor() {}

	wrapFunction(fn, context, params) {
		return function() {
			fn.apply(context, params);
		};
	}

	closeAllModalsAndOpenNew(newModal: string): void {
		const $modals = $('.modal.in');

		if ($modals.length) {
			$modals.modal('hide').on('hidden.bs.modal', function() {
				$(newModal).modal('show');
				$(this).off('hidden.bs.modal');
			});
		} else {
			$(newModal).modal('show');
		}
	}

	showNextModal(selectModal, nextModal, e) {
		if (e) {
			e.preventDefault();
		}

		const modal = document.querySelector(selectModal);
		if (modal) {
			const modalIsShown = modal.classList.contains('in');
			if (!modalIsShown) {
				$(nextModal).modal('show');
			} else {
				$(selectModal)
					.modal('hide')
					.on('hidden.bs.modal', function() {
						$(nextModal).modal('show');
						$(this).off('hidden.bs.modal'); // Remove the 'on' event binding
					});
			}
		} else {
			$(nextModal).modal('show');
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/utils/utils-service.ts